{
  "main": {
    "title": "CAMO Inspections"
  },
  "menu": {
    "plovila": {
      "title": "Aircraft",
      "description": "Overview of number of flights and total flight hours"
    },
    "liste": {
      "title": "Start Lists",
      "description": "Overview of start lists"
    }
  }
}
